import styled from "@emotion/styled";
import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../strings";
import { globalize, translate } from "../translate";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import { If } from "./Generic/If";
import { VisitTimeRange } from "./VisitTimeRange";

type Props = {
  index: number;
  startDateTime: LocalDateTime;
  endDateTime: LocalDateTime;
  isCurrentDay: boolean;
  caregiverName: string;
  caregiverPhoneNumber: string | null;
};

export const PatientScheduleVisitCard: React.FC<Props> = ({
  index,
  startDateTime,
  endDateTime,
  isCurrentDay,
  caregiverName,
  caregiverPhoneNumber,
}) => {
  const startDate = startDateTime.toLocalDate();

  return (
    <div className="CaregiverScheduleScreen__dateContainer" id={`day${startDate}`}>
      <div className="CaregiverScheduleScreen__visitDate">
        <If condition={isCurrentDay}>
          <span className="CurrentDay">{translate(STRINGS.TODAY)}</span>
        </If>
        <span className="DayOfWeek">
          {globalize().formatDayOfWeek(startDate.dayOfWeek(), true)}
        </span>
        <span className="DayOfMonth">{startDate.dayOfMonth()}</span>
      </div>
      <div className="CaregiverScheduleScreen_visitsContainer">
        <AppCard
          className="CaregiverScheduleScreen_visit"
          style={{ animationDelay: `${Math.min(index * 75, 500)}ms` }}
        >
          <AppCardContent>
            <div>
              <Title>{caregiverName}</Title>
              {caregiverPhoneNumber !== null && <SubTitle>{caregiverPhoneNumber}</SubTitle>}
            </div>
            <VisitTimeRange startDateTime={startDateTime} endDateTime={endDateTime} />
          </AppCardContent>
        </AppCard>
      </div>
    </div>
  );
};

const Title = styled.h3`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 100%;
  color: var(--accent);
  margin-bottom: 8px;
`;

const SubTitle = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
`;
